import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpDown } from '@/fontawesome.ts';
import Modal from '@/components/ui/Modal.tsx';
import SwingTradeAdjustementsTable from '@/components/trading/SwingTradeAdjustementsTable.tsx';
import EditSwingTradeAdjustementModal from '@/components/admin/recommendations/EditSwingTradeAdjustementModal.tsx';
import type { RecommendationSwingtrade, SwingTradeAdjustement } from '@/models';

interface ViewSwingTradeAdjustmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  swingTrade: RecommendationSwingtrade | null;
  onSwingTradeUpdated: (swingTrade: RecommendationSwingtrade) => void;
  isAdmin?: boolean;
}

export default function ViewSwingTradeAdjustmentsModal({
  isOpen,
  onClose,
  swingTrade,
  onSwingTradeUpdated,
  isAdmin = false,
}: ViewSwingTradeAdjustmentsModalProps) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingAdjustment, setEditingAdjustment] = useState<SwingTradeAdjustement | null>(null);

  if (!swingTrade) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={`Einstiege für ${swingTrade.symbolTicker}`}
        icon={<FontAwesomeIcon icon={faUpDown} className="w-5 h-5 text-purple-600 dark:text-purple-400" />}
        maxWidth="4xl"
      >
        <div className="p-6">
          {swingTrade.adjustements.length === 0 ? (
            <div className="text-center py-8 text-gray-500 dark:text-gray-400">
              <p className="text-lg font-medium">Keine Einstiege vorhanden</p>
              <p className="text-sm mt-2">
                Für diesen Swing Trade wurden noch keine Einstiege vorgenommen.
              </p>
            </div>
          ) : (
            <SwingTradeAdjustementsTable
              swingTrade={swingTrade}
              onEdit={(adjustment) => {
                setEditingAdjustment(adjustment as SwingTradeAdjustement);
                setIsEditModalOpen(true);
              }}
              onDelete={() => {
                // Delete is handled in the table component
              }}
              onSwingTradeUpdated={(trade) => onSwingTradeUpdated(trade as RecommendationSwingtrade)}
              showActions={isAdmin}
            />
          )}
        </div>
      </Modal>

      <EditSwingTradeAdjustementModal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setEditingAdjustment(null);
        }}
        swingTrade={swingTrade}
        adjustment={editingAdjustment}
        onAdjustmentUpdated={onSwingTradeUpdated}
      />
    </>
  );
}
